import { render, staticRenderFns } from "./ExpansionDetails.vue?vue&type=template&id=777501e6&"
import script from "./ExpansionDetails.vue?vue&type=script&lang=js&"
export * from "./ExpansionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports